import { createAction } from "@reduxjs/toolkit";
import { CustomGiftType } from "src/features/customGift/api/customGiftTypes";

export const setCustomGifts = createAction<CustomGiftType[]>(
  "lwc/customGift/setCustomGifts"
);
